module.exports = __webpack_public_path__ + "img/icon-install-primary.d972166e.svg";